import React from "react"
import RightArrow from "../../../../media/landing-page/right-arrow.png"
import * as s from "./service.module.less"
import cn from "classnames";
const Service = ({service}) => {
	const removeReadMore = !service.excerpt?.length || service.hideReadMore
  return (
    <div className={ cn(s.service, {
		[s.smaller]: removeReadMore
	}) }>
      <img className={ s.serviceImg } src={ service.img } alt={ service.title }/>
      <div className={ s.textBox }>
        <div className={ s.titleBox }>
          <h2 className={ s.title }>{service.title}</h2>
        </div>
        <p className={ s.description }>{service.description}</p>
      </div>
      <div className={ cn(s.btnBox, {
		  [s.hide]: removeReadMore
	  }) }>
        <button className={ s.btn } onClick={ service.btn.onClick }>
          <a href={ service.btn.href }>
            { service.btn.text.toUpperCase() }
          </a>
        </button>
        <img
          alt="Right-Arrow"
          className={ s.rightArrow }
          src={ RightArrow }
        />
      </div>
    </div>
  )
}
export default Service
